"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideClick = useOutsideClick;
exports.default = void 0;

var _react = require("react");

/**
 * useOutsideClick - This hook is used for cases where we need to detect if a
 * user has tapped *outside* of the specified element, and perform an action.
 *
 * For example: if a user taps outside of a modal element, in order to close
 * the modal.
 *
 * It returns a tuple that includes a ref object and a boolean value. The ref
 * should be assigned to a React component, where the `ref.current` value
 * represents the HTML Element we want to detect taps outside of. The boolean
 * is an value that represents if an outside click has been detected.
 */
function useOutsideClick(ref, onClick, active) {
  const [clickedOutside, setClickedOutside] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (active && clickedOutside && typeof onClick === 'function') {
      onClick();
    }
  }, [active, clickedOutside, onClick]);
  (0, _react.useEffect)(() => {
    function handleEvent(e) {
      if (ref && ref.current) {
        setClickedOutside(!ref.current.contains(e.target));
      }
    }

    document.addEventListener('mousedown', handleEvent);
    document.addEventListener('touchstart', handleEvent);
    return () => {
      document.removeEventListener('mousedown', handleEvent);
      document.removeEventListener('touchstart', handleEvent);
    };
  }, [active, ref]);
}

var _default = useOutsideClick;
exports.default = _default;
//# sourceMappingURL=useOutsideClick.js.map